// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3682d148","455":"386f0199"}[chunkId] + ".chunk.js";
};